import React, { useState, useEffect, useCallback } from 'react';
import { Select, Pagination } from 'antd';
import { toast } from 'react-toastify';
import Spinner from './spinner';
import ApplicationService from '../services/axios.service';

const ForecastDetailsNew = () => {
  const currentYear = new Date().getFullYear();
  
  const [availableYears, setAvailableYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [selectedQuarter, setSelectedQuarter] = useState(['Q1']);
  const [loading, setLoading] = useState(false);
  const [forecastRecords, setForecastRecords] = useState([]);
  const [monthHeaders, setMonthHeaders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [customers, setCustomers] = useState([]);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const service = new ApplicationService();
  const customerColumnStyle = { minWidth: '150px', width: '150px', left: 0 };
  const criteriaColumnStyle = { minWidth: '120px', width: '120px', left: '150px' };
  const columnGroups = [
    { name: 'Firm PO', field: 'firm_po', color: '#FFFACD' },
    { name: 'Firm PO Risk', field: 'firm_po_risk', color: '#FFFFFF' },
    { name: 'Low Risk', field: 'low_risk', color: '#FFFACD' },
    { name: 'High Risk', field: 'high_risk', color: '#FFFFFF' },
    { name: 'Mark Up Historical', field: 'mark_up_historical', color: '#FFFACD' }
  ];

  const getFcFieldForMonth = (monthLabel, previous = false) => {
  // Extract month name from label like "Apr 2026" or "Apr-26"
  const monthName = monthLabel.split(/[\s-]/)[0];

  // Normalize month name, so APr, APR, apr all become Apr
  const normalizedMonth =
    monthName.charAt(0).toUpperCase() + monthName.slice(1).toLowerCase();

  const monthMap = {
    Apr: 1,
    May: 2,
    Jun: 3,
    Jul: 4,
    Aug: 5,
    Sep: 6,
    Oct: 7,
    Nov: 8,
    Dec: 9,
    Jan: 10,
    Feb: 11,
    Mar: 12
  };

  let fcNumber = monthMap[normalizedMonth] || 1;

  // If previous month is required
  if (previous) {
    fcNumber = fcNumber === 1 ? 12 : fcNumber - 1;
  }

  return `fc${fcNumber}`;
};
  const getFcFieldForMonth1 = (monthLabel,previous = false) => {
    // Extract month name from label like "Apr 2026" or "Apr-26"
    const monthName = monthLabel.split(/[\s-]/)[0];
    
    const monthMap = {
      'Apr': 'fc1', 'May': 'fc2', 'Jun': 'fc3',
      'Jul': 'fc4', 'Aug': 'fc5', 'Sep': 'fc6',
      'Oct': 'fc7', 'Nov': 'fc8', 'Dec': 'fc9',
      'Jan': 'fc10', 'Feb': 'fc11', 'Mar': 'fc12'
    };
    
    return monthMap[monthName] || 'fc1';
  };


  const getFcLabelForMonth = (monthLabel, previous = false) => {
  const monthName = monthLabel.split(/[\s-]/)[0];

  // Normalize month name: APr, APR, apr => Apr
  const normalizedMonth =
    monthName.charAt(0).toUpperCase() + monthName.slice(1).toLowerCase();

  const monthMap = {
    Apr: 1,
    May: 2,
    Jun: 3,
    Jul: 4,
    Aug: 5,
    Sep: 6,
    Oct: 7,
    Nov: 8,
    Dec: 9,
    Jan: 10,
    Feb: 11,
    Mar: 12
  };

  let fcNumber = monthMap[normalizedMonth] || 1;

  if (previous) {
    fcNumber = fcNumber === 1 ? 12 : fcNumber - 1;
  }

  return `FC${fcNumber}`;
};
  const getFcLabelForMonth1 = (monthLabel) => {
    const monthName = monthLabel.split(/[\s-]/)[0];
    
    const monthMap = {
      'Apr': 'FC1', 'May': 'FC2', 'Jun': 'FC3',
      'Jul': 'FC4', 'Aug': 'FC5', 'Sep': 'FC6',
      'Oct': 'FC7', 'Nov': 'FC8', 'Dec': 'FC9',
      'Jan': 'FC10', 'Feb': 'FC11', 'Mar': 'FC12'
    };
    
    return monthMap[monthName] || 'FC1';
  };

  const fetchForecastDetails = async (page = 1, limit = 100) => {
    if (selectedQuarter.length === 0) {
      toast.warning('Please select at least one quarter');
      return;
    }

    setLoading(true);
    try {
      const payload = {
        year: selectedYear.toString(),
        quarters: selectedQuarter.join(','),
        page,
        limit
      };

      const response = await service.post('sales-total/forecast-details', payload);
      
      // Check for success flag instead of statusCode
      if (response.data.success && response.data.data) {
        setForecastRecords(response.data.data.records || []);
        setMonthHeaders(response.data.data.months || []);
        setTotal(response.data.data.pagination?.total || 0);
        setCurrentPage(response.data.data.pagination?.page || 1);
        toast.success(response.data.message || 'Forecast details fetched successfully!');
      } else {
        setForecastRecords([]);
        setMonthHeaders([]);
        setTotal(0);
        toast.info('No data found');
      }
    } catch (error) {
      console.error('Error fetching forecast details:', error);
      toast.error('Failed to fetch forecast details');
      setForecastRecords([]);
      setMonthHeaders([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page, size) => {
    setCurrentPage(page);
    setPageSize(size);
    fetchForecastDetails(page, size);
  };

  const fetchYears = async () => {
    try {
      const response = await service.getSalesTotalYears();
      if (response.data.statusCode === 200) {
        const years = response.data.data || [];
        // Convert to numbers and remove duplicates
        const uniqueYears = [...new Set(years.map(year => Number(year)))].sort((a, b) => b - a);
        setAvailableYears(uniqueYears);
        if (uniqueYears.length > 0) {
          setSelectedYear(uniqueYears[0]);
        }
      }
    } catch (error) {
      console.error('Error fetching years:', error);
      setAvailableYears([currentYear]);
    }
  };

  const fetchCustomers = useCallback(async () => {
    try {
      const response = await service.getSalesTotalCustomers();
      if (response.data.statusCode === 200) {
        const customerList = response.data.data.forecast || [];
        setCustomers(customerList);
        if (customerList.length > 0) {
          setSelectedCustomer(customerList[0].customer_id);
        }
      }
    } catch (error) {
      console.error('Error fetching customers:', error);
      setCustomers([]);
    }
  }, []);

  useEffect(() => {
    fetchYears();
    fetchCustomers();
  }, [fetchCustomers]);

  // Group records by customer
  const groupedByCustomer = forecastRecords.reduce((acc, record) => {
    const customerId = record.customer_id;
    if (!acc[customerId]) {
      acc[customerId] = {
        customer_name: record.customer_name,
        criteria: [],
        // total_value:100
      };
    }
    acc[customerId].criteria.push(record);
    return acc;
  }, {});

  const allMonthsKeys = Object.entries(Object.values(groupedByCustomer)[0]?.criteria[0]?.months || {}).reduce((acc, [monthName, monthValues]) => {
    acc[monthName] = Object.keys(monthValues);
    return acc;
  }, {});

  const formatAmount = (value) => (
    (Number(value) || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  );

  const getMonthTotals = (criteria, month) => {
    const fcField = getFcFieldForMonth(month, false);
    const previousFcField = getFcFieldForMonth(month, true);
    const comparisonField = allMonthsKeys[month]?.[1];

    return criteria.reduce((totals, record) => {
      const monthData = record.months?.[month] || {};
      const fcValue = parseFloat(monthData[fcField]) || 0;
      const comparisonValue = parseFloat(monthData[comparisonField]) || 0;
      const previousFcValue = parseFloat(monthData[previousFcField]) || 0;

      return {
        fc: totals.fc + fcValue,
        firmPo: totals.firmPo + (parseFloat(monthData.firm_po) || 0),
        firmPoRisk: totals.firmPoRisk + (parseFloat(monthData.firm_po_risk) || 0),
        lowRisk: totals.lowRisk + (parseFloat(monthData.low_risk) || 0),
        highRisk: totals.highRisk + (parseFloat(monthData.high_risk) || 0),
        markUpHistorical: totals.markUpHistorical + (parseFloat(monthData.mark_up_historical) || 0),
        comparison: totals.comparison + comparisonValue,
        vsComparison: totals.vsComparison + (comparisonValue - fcValue),
        previousFc: totals.previousFc + previousFcValue,
        vsPreviousFc: totals.vsPreviousFc + (previousFcValue - fcValue)
      };
    }, {
      fc: 0,
      firmPo: 0,
      firmPoRisk: 0,
      lowRisk: 0,
      highRisk: 0,
      markUpHistorical: 0,
      comparison: 0,
      vsComparison: 0,
      previousFc: 0,
      vsPreviousFc: 0
    });
  };

  console.log('`Grouped by customer`:', groupedByCustomer);
  return (
    <div className="p-4 bg-[#f9fafb]">
      <h2 className="text-2xl font-bold mb-4">Forecast Details</h2>

      <div className="bg-white p-4 rounded-lg shadow-md mb-4">
        <div style={{ display: 'flex', gap: '20px', alignItems: 'center', flexWrap: 'wrap' }}>
          <div>
            <label style={{ marginRight: '8px', fontWeight: 'bold' }}>Year:</label>
            <select 
              value={selectedYear} 
              onChange={(e) => setSelectedYear(parseInt(e.target.value))}
              style={{
                padding: '8px 12px',
                borderRadius: '4px',
                border: '1px solid #ccc',
                fontSize: '14px',
                cursor: 'pointer',
                minWidth: '120px'
              }}
            >
              {availableYears.map((year) => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
          </div>

          <div>
            <label style={{ marginRight: '8px', fontWeight: 'bold' }}>Quarter:</label>
            <Select
              mode="multiple"
              placeholder="Select Quarter(s)"
              value={selectedQuarter}
              onChange={(values) => setSelectedQuarter(values)}
              style={{ minWidth: 280 }}
              size="large"
              options={[
                { label: 'Q1 (Apr-Jun)', value: 'Q1' },
                { label: 'Q2 (Jul-Sep)', value: 'Q2' },
                { label: 'Q3 (Oct-Dec)', value: 'Q3' },
                { label: 'Q4 (Jan-Mar)', value: 'Q4' },
              ]}
            />
          </div>

          <button
            onClick={() => fetchForecastDetails(1, pageSize)}
            disabled={loading}
            style={{
              padding: '8px 24px',
              backgroundColor: loading ? '#ccc' : '#3D3D3D',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: loading ? 'not-allowed' : 'pointer',
              fontSize: '14px',
              fontWeight: 'bold'
            }}
          >
            {loading ? 'Loading...' : 'Search'}
          </button>
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center items-center py-10">
          <Spinner />
        </div>
      ) : forecastRecords.length > 0 ? (
        <>
          <div className="bg-white rounded-lg shadow-md p-4">
            <div 
              className="overflow-x-auto overflow-y-auto" 
              style={{ maxHeight: '600px' }}
            >
              <table className="min-w-full border-collapse border border-gray-300" style={{ fontSize: '12px' }}>
                <thead className="sticky top-0 z-20">
                  <tr className="bg-[#FFFF00]">
                    <th 
                      className="border border-gray-300 px-2 py-1 text-center sticky left-0 bg-[#00FFFF] z-30" 
                      rowSpan="2"
                      style={customerColumnStyle}
                    >
                      Customer
                    </th>
                    <th 
                      className="border border-gray-300 px-2 py-1 text-center sticky left-[150px] bg-[#00FFFF] z-30" 
                      rowSpan="2"
                      style={criteriaColumnStyle}
                    >
                      Criteria
                    </th>
                    {monthHeaders.map((month, idx) => (
                      <th key={idx} className="border border-gray-300 px-2 py-1 text-center" colSpan="10">
                        {month}
                      </th>
                    ))}
                    <th 
                      colSpan={columnGroups.length+3}
                      className="border border-gray-300 px-2 py-1 text-center bg-[#00FFFF]"
                    >
                      Total
                    </th>
                  </tr>
                  <tr className="bg-blue-100">
                    {monthHeaders.map((month, idx) => {
                      const fcLabel = getFcLabelForMonth(month);
                      const fcLabel1 = getFcLabelForMonth(month, true);
                      
                      return (
                        <React.Fragment key={idx}>
                          <th className="border border-gray-300 px-2 py-1 text-center" style={{ minWidth: '100px', backgroundColor: '#E3F2FD' }}>
                            {fcLabel}
                          </th>
                          <th className="border border-gray-300 px-2 py-1 text-center" style={{ minWidth: '100px', backgroundColor: '#FFFACD' }}>
                            Firm PO
                          </th>
                          <th className="border border-gray-300 px-2 py-1 text-center" style={{ minWidth: '100px', backgroundColor: '#FFFFFF' }}>
                            Firm PO Risk
                          </th>
                          <th className="border border-gray-300 px-2 py-1 text-center" style={{ minWidth: '100px', backgroundColor: '#FFFACD' }}>
                            Low Risk
                          </th>
                          <th className="border border-gray-300 px-2 py-1 text-center" style={{ minWidth: '100px', backgroundColor: '#FFFFFF' }}>
                            High Risk
                          </th>
                          <th className="border border-gray-300 px-2 py-1 text-center" style={{ minWidth: '100px', backgroundColor: '#FFFACD' }}>
                            Mark Up Historical
                          </th>
                         <th className="border border-gray-300 px-2 py-1 text-center" style={{ minWidth: '100px', backgroundColor: '#FFFACD' }}>
                           {allMonthsKeys[month]?.[1]}
                          </th>
                            <th className="border border-gray-300 px-2 py-1 text-center" style={{ minWidth: '100px', backgroundColor: '#E3F2FD' }}>
                           vs {allMonthsKeys[month]?.[1]}
                          </th>
                           <th className="border border-gray-300 px-2 py-1 text-center" style={{ minWidth: '100px', backgroundColor: '#E3F2FD' }}>
                            {fcLabel1}
                          </th>
                          <th className="border border-gray-300 px-2 py-1 text-center" style={{ minWidth: '100px', backgroundColor: '#E3F2FD' }}>
                           vs {fcLabel1}
                          </th>
                         
                        </React.Fragment>
                      );
                    })}
                  </tr>
                </thead>
                <tbody>
                  {Object.values(groupedByCustomer).map((customer, custIdx) => {
                    const criteriaCount = customer.criteria.length;
                    // <tr>
                    //   <td></td>
                    //   <td></td>

                    //   <td></td>

                    //   <td></td>

                    //   <td></td>

                    // </tr>
                    return (
                      <React.Fragment key={custIdx}>
                         {/* <tr>
                               <th  > Totals</th>
                               <td></td>

                               <td></td>

                               <td></td>

                               <td></td>

                               <td></td>
                               <td></td>


                             </tr> */}
                        {customer.criteria.map((record, recIdx) => (
                          <React.Fragment key={`${custIdx}-${recIdx}`}>
                            {recIdx === 0 && (
                            <tr>
                              <th
                                className="border border-gray-300 px-2 py-1 text-sm sticky left-0 bg-white z-20"
                                style={{ ...customerColumnStyle, borderBottom: 'none' }}
                              ></th>
                              
                              <th
                                className="border border-gray-300 px-2 py-1 text-sm sticky left-[150px] bg-white z-20"
                                style={criteriaColumnStyle}
                              >
                                Total
                              </th>
                              {monthHeaders.map((month) => {
                                const monthTotals = getMonthTotals(customer.criteria, month);

                                return (
                                  <React.Fragment key={`total-${custIdx}-${month}`}>
                                    <td className="border border-gray-300 px-2 py-2 font-medium bg-white text-center">{formatAmount(monthTotals.fc)}</td>
                                    <td className="border border-gray-300 px-2 py-2 font-medium bg-white text-center">{formatAmount(monthTotals.firmPo)}</td>
                                    <td className="border border-gray-300 px-2 py-2 font-medium bg-white text-center">{formatAmount(monthTotals.firmPoRisk)}</td>
                                    <td className="border border-gray-300 px-2 py-2 font-medium bg-white text-center">{formatAmount(monthTotals.lowRisk)}</td>
                                    <td className="border border-gray-300 px-2 py-2 font-medium bg-white text-center">{formatAmount(monthTotals.highRisk)}</td>
                                    <td className="border border-gray-300 px-2 py-2 font-medium bg-white text-center">{formatAmount(monthTotals.markUpHistorical)}</td>
                                    <td className="border border-gray-300 px-2 py-2 font-medium bg-white text-center">{formatAmount(monthTotals.comparison)}</td>
                                    <td className="border border-gray-300 px-2 py-2 font-medium bg-white text-center">{formatAmount(monthTotals.vsComparison)}</td>
                                    <td className="border border-gray-300 px-2 py-2 font-medium bg-white text-center">{formatAmount(monthTotals.previousFc)}</td>
                                    <td className="border border-gray-300 px-2 py-2 font-medium bg-white text-center">{formatAmount(monthTotals.vsPreviousFc)}</td>
                                  </React.Fragment>
                                );
                              })}
                            </tr>
                            )}
                          
                          <tr key={`${custIdx}-${recIdx}`} className="bg-white hover:bg-gray-50">
                            {recIdx === 0 && (
                              <td 
                                className="border border-gray-300 px-2 py-2 font-medium sticky left-0 bg-white z-10 text-center"
                                rowSpan={criteriaCount}
                                style={{ ...customerColumnStyle, borderTop: 'none' }}
                              >
                                {customer.customer_name}
                              </td>
                            )}
                            
                            <td 
                              className="border border-gray-300 px-2 py-1 text-sm sticky left-[150px] bg-white z-10"
                              style={criteriaColumnStyle}
                            >
                              {record.criteria} 
                            </td>
                            
                            
                            {/* Month-wise data */}
                            {monthHeaders.map((month, mIdx) => {
                              
                              const monthData = record.months?.[month] || {};
                              console.log('Processing month:', monthData);
                              const fcField = getFcFieldForMonth(month,false);
                              const fcField1 = getFcFieldForMonth(month,true);
                              const comparisonField = allMonthsKeys[month]?.[1];
                              return (
                                <React.Fragment key={mIdx}>
                                  {/* <tr>
                                    <td className="border border-gray-300 px-2 py-1 text-center" style={{ backgroundColor: '#E3F2FD' }}>
                                      {getFcLabelForMonth(month)}
                                    </td>
                                  </tr> */}
                                  <td className="border border-gray-300 px-2 py-1 text-center" style={{ backgroundColor: '#E3F2FD' }}>
                                    {(monthData[fcField] || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}  
                                  </td>
                                  <td className="border border-gray-300 px-2 py-1 text-center" style={{ backgroundColor: '#FFFACD' }}>
                                    {(monthData.firm_po || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                  </td>
                                  <td className="border border-gray-300 px-2 py-1 text-center" style={{ backgroundColor: '#FFFFFF' }}>
                                    {(monthData.firm_po_risk || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                  </td>
                                  <td className="border border-gray-300 px-2 py-1 text-center" style={{ backgroundColor: '#FFFACD' }}>
                                    {(monthData.low_risk || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                  </td>
                                  <td className="border border-gray-300 px-2 py-1 text-center" style={{ backgroundColor: '#FFFFFF' }}>
                                    {(monthData.high_risk || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                  </td>
                                  <td className="border border-gray-300 px-2 py-1 text-center" style={{ backgroundColor: '#FFFACD' }}>
                                    {(monthData.mark_up_historical || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                  </td>
                                   <td className="border border-gray-300 px-2 py-1 text-center" style={{ backgroundColor: '#FFFACD' }}>
                                   {(monthData[comparisonField] || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                  </td>
                                     <td className="border border-gray-300 px-2 py-1 text-center" style={{ backgroundColor: '#FFFACD' }}>
                                   {((monthData[comparisonField] || 0)-monthData[fcField] || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                  </td>
                                  
                                  <td className="border border-gray-300 px-2 py-1 text-center" style={{ backgroundColor: '#E0FFFF' }}>
                                    {(monthData[fcField1] || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                  </td>
                                    <td className="border border-gray-300 px-2 py-1 text-center" style={{ backgroundColor: '#E0FFFF' }}>
                                    {(monthData[fcField1]-monthData[fcField] || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                  </td>
                               
                                </React.Fragment>
                              );
                              
                            })}
                            
                            {/* Total columns */}
                            {columnGroups.map((col, cIdx) => {
                              
                              const totalValue = parseFloat(record.totals?.[col.field]) || 0;
                              return (
                                <td 
                                  key={`total-${cIdx}`}
                                  className="border border-gray-300 px-2 py-1 text-center text-sm font-semibold"
                                  style={{ backgroundColor: '#E0FFFF' }}
                                >
                                  {totalValue.toFixed(2)} 
                                </td>
                              );
                            })}
                          </tr>
                            </React.Fragment>
                        ))}
                      </React.Fragment>
                    );
                    
                  })}
                </tbody>
              </table>
            </div>
          </div>

          {total > pageSize && (
            <div className="mt-4 flex justify-end">
              <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={total}
                onChange={handlePageChange}
                showSizeChanger
                pageSizeOptions={['100', '200', '500']}
                showTotal={(total) => `Total ${total} records`}
              />
            </div>
          )}
        </>
      ) : (
        <div className="text-center py-8 text-gray-500">
          No forecast details available. Please select year and quarter(s) and click Search.
        </div>
      )}
    </div>
  );
};

export default ForecastDetailsNew;










